import { customerColumns, customerData } from '../../../Data/Customers/CustomerTickets';
import React, { Fragment} from 'react';
import CommonDataTable from '../../Common/Component/CommonDataTable';
const CustomerTicketsTable = () => {
    const processData=customerData.map(element=>{
        return {
            ticket_number: element.ticket_number,
            booking_number: element.booking_number,
            subject: element.subject,
            description: element.description,
            status: element.status,
            priority: element.priority,
            reported_on: element.reported_on
        }
    })
    return (
        <Fragment>
            <div className="table-responsive customer-ticket">
                <CommonDataTable options={{
                    columns:customerColumns,
                    data:processData,
                    center:true,
                    fixedHeaderScrollHeight:'45vh'
                }}
                />
            </div>
        </Fragment>
    );
};
export default CustomerTicketsTable;